// extracted by mini-css-extract-plugin
export var container = "index-module--container--2HnPI";
export var grid = "index-module--grid--PYu17";
export var card = "index-module--card--m4hxa";
export var intro = "index-module--intro--3eyHJ";